// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1fE10","errors":"Errors_errors__1lj0L"};